import findGameInTheList from '../../entities/findGameInTheList';
import removeSwipeSdk from '../../features/removeSwipeSdk';
import { LocalStoreKeys } from '../enums/localStoreKeys';
import getCurrentGameSelected from '../lib/currentGameSelected';
import { setLocalStore } from '../lib/localStore';
import { SwipeGamesItem } from '../model/swipe';
import { isTenantFeatureEnabled } from '../helpers/tenantFeatureHelper';
import { TenantFeature } from '../enums/tenantFeatures';
import { updateGameViewportHeight } from '../lib/updateGameViewportHeight';
import { isNewMenuEnabled } from '../lib/isNewSwipeDesign';

export const createIframe = (src: string | null | undefined) => {
  if (!src) return;

  const existingFrameId = document.getElementById('swipeSDKFrame');
  existingFrameId?.remove();

  const existingFrameContainer = document.getElementById(
    'swipe-sdk__frame-container',
  );
  const loaderIcon = document.getElementById('loader__icon');

  if (!existingFrameContainer || !loaderIcon) return;

  const currentGameSelected = getCurrentGameSelected();
  const foundGame = findGameInTheList(
    currentGameSelected.currentGameId,
  ) as SwipeGamesItem;

  loaderIcon.style.display = 'block';

  const iframe = document.createElement('iframe');
  iframe.id = 'swipeSDKFrame';
  iframe.src = src;

  const isNewDesign = isNewMenuEnabled();
  const isDrawerMode = isTenantFeatureEnabled([TenantFeature.DRAWER_MENU]);
  const baseStyles = {
    width: '100vw',
    position: 'fixed',
    maxHeight: '100%',
    border: 'none',
    display: 'block',
    backgroundColor: 'transparent',
    height: 'calc(var(--vh, 1vh) * 100)',
  };

  const styleToApply = {
    ...baseStyles,
    ...(isDrawerMode || isNewDesign ? {} : { top: '0px' }),
  };

  Object.assign(iframe.style, styleToApply);

  const isIframeGradientEnabled = isTenantFeatureEnabled([
    TenantFeature.IFRAME_GRADIENT,
  ]);

  if (foundGame?.colorGradient?.length > 0) {
    iframe.style.background = isIframeGradientEnabled
      ? 'transparent'
      : `linear-gradient(${foundGame.colorGradient.join(',')})`;
  }

  if (!isNewDesign) {
    if (isDrawerMode) {
      document.documentElement.style.setProperty(
        '--vh',
        `${(window.innerHeight - 64) * 0.01}px`,
      );
    } else {
      document.documentElement.style.setProperty(
        '--vh',
        `${window.innerHeight * 0.01}px`,
      );
    }
  }

  iframe.addEventListener('load', () => {
    try {
      const iframeHost = iframe.contentWindow?.location?.host;

      if (iframeHost === location.host) {
        removeSwipeSdk();
        setLocalStore(LocalStoreKeys.IS_SWIPE_SDK_INITIATED, false);
        console.warn('Iframe navigated to same-origin URL. Swipe SDK removed.');
        return;
      }
    } catch (e) {
      console.warn(
        'CORS restriction: Cannot access iframe URL. Continuing normally...',
      );
    }

    loaderIcon.style.display = 'none';

    if (foundGame?.colorGradient?.length > 0) {
      iframe.style.background = isIframeGradientEnabled
        ? 'transparent'
        : `linear-gradient(${foundGame.colorGradient.join(',')})`;
    }
  });

  existingFrameContainer.appendChild(iframe);

  if (isNewDesign) {
    updateGameViewportHeight();
  }
};
